import * as actions from './actions'
import { DashboardState } from './model'
import { DashboardsActions } from './actions'

const initialState: DashboardState =  <DashboardState> {
    'orgId': -1,
    'dashboards': [],
    'filteredDashboards': [],
    'loading': true,
    'query': '',
};

const reducer = (state: DashboardState = initialState, action: DashboardsActions): DashboardState => {
  switch (action.type) {
      case actions.LoadingDashboards:
          return {
              ...state,
              loading: true
          };
      case actions.ChangeDashboards:
          return {
              ...state,
              dashboards: action.payload.dashboard,
              filteredDashboards: action.payload.filtered,
              loading: false
          };
      case actions.QueryChangeDashboards:
          return {
              ...state,
              query: action.payload.query,
              filteredDashboards: action.payload.filteredDashboard
          };
    default:
      return state
  }
};

export default reducer
